// @core/api/endpoints/task/update_custom_field_definition.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CustomFieldDefinitionResponse,
  UpdateCustomFieldDefinitionRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Update custom field
 * Updates a custom field definition (display name, options, validation, position). Existing values on tasks are not affected.
 */
export async function UpdateCustomFieldDefinition(
  field_id: string,
  data: UpdateCustomFieldDefinitionRequest,
  options?: RequestOptions
): Promise<CustomFieldDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/custom-fields/:field_id`;
  requestPath = requestPath.replace(':field_id', encodeURIComponent(field_id));
  const requestOptions = options;
  return client.put<CustomFieldDefinitionResponse>(requestPath, data, requestOptions);
}
